(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/components/login-required-route.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/components/login-required-route.js');
"use strict";

const _excluded = ["cancelUrl", "component"];
var _svs$tickets;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const {
  Route
} = svs.app.ReactRouter;
const branding = (_svs$tickets = svs.tickets) === null || _svs$tickets === void 0 ? void 0 : _svs$tickets.data.templateConfig.branding;
const LoginRequiredRoute = _ref => {
  let {
      cancelUrl,
      component: Component
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return React.createElement(Route, _extends({
    component: props => {
      const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
      const extraParams = {
        ticketsorderhome: true,
        branding
      };
      if (isLoggedIn) {
        var _svs, _svs$setupExtraData;
        (_svs = svs) === null || _svs === void 0 || (_svs = _svs.accountservices) === null || _svs === void 0 || (_svs = _svs.onboardingHandler) === null || _svs === void 0 || (_svs$setupExtraData = _svs.setupExtraData) === null || _svs$setupExtraData === void 0 || _svs$setupExtraData.call(_svs, {
          extraData: extraParams
        });
        return React.createElement(Component, props);
      }
      svs.components.customer_login.login({
        cancelUrl,
        returnNewCustomer: true,
        extraParams
      });
      return null;
    }
  }, rest));
};
setGlobal('svs.ticketsOrderHome.components.LoginRequiredRoute', LoginRequiredRoute);

 })(window);